import { graphql, useLazyLoadQuery } from 'react-relay';
import { useMorePageQuery as useMoreQmeePageQueryType } from './__generated__/useMorePageQuery.graphql';

const morePageQuery = graphql`
  query useMorePageQuery {
    userData {
      firstName
    }
    ...useMoreSurveysBannerQuery_profileUrlRef
  }
`;

export function useMorePageQuery() {
  return useLazyLoadQuery<useMoreQmeePageQueryType>(
    morePageQuery,
    {},
    {
      fetchPolicy: 'store-or-network',
    },
  );
}
